export const styles = {
  container: {
    cursor: "pointer",
    color: "text.primary",
    width: "458px",
    gap: "20px",
    height: "45px",
  },
  textContainer: {
    whiteSpace: "nowrap",
  },
  mobileText: {
    marginLeft: 4,
  },
};
